export const messageListKeys = {
  all: ['messageList'] as const,
  conversation: (conversationId: string) => [...messageListKeys.all, conversationId] as const,
  listPinned: (conversationId: string) => [...messageListKeys.all, 'pinned', conversationId] as const,
  reactions: (conversationId: string, messageId: string, filter?: string, pageSize?: number) =>
    [...messageListKeys.all, 'reactions', conversationId, messageId, filter, pageSize] as const
};
